<rotec-pages-v2>
  @if ((routingConfig$ | async)?.statistics) {
    <a [routerLink]="statisticsLink" routerLinkActive="pages-active-link">
      <h3 translate>MC_Statistics</h3>
    </a>
  }
  @if ((routingConfig$ | async)?.production) {
    <a [routerLink]="productionLink" routerLinkActive="pages-active-link">
      <h3 translate>MC_Production</h3>
    </a>
  }
  @if ((routingConfig$ | async)?.quality) {
    <a [routerLink]="qualityLink" routerLinkActive="pages-active-link">
      <h3 translate>MC_Quality</h3>
    </a>
  }
  @if ((routingConfig$ | async)?.operators) {
    <a [routerLink]="operatorsLink" routerLinkActive="pages-active-link">
      <h3 translate>MC_Operators</h3>
    </a>
  }
  @if ((routingConfig$ | async)?.notifications) {
    <a [routerLink]="notificationsLink" routerLinkActive="pages-active-link">
      <h3 translate>MC_Notifications</h3>
      @if (state.nrOfNotificationsSinceLastVisit) {
        <p>
          {{ state.nrOfNotificationsSinceLastVisit }}
        </p>
      }
    </a>
  }
  @if ((routingConfig$ | async)?.condition) {
    <a [routerLink]="conditionLink" routerLinkActive="pages-active-link">
      <h3 translate>MC_Condition</h3>
    </a>
  }
</rotec-pages-v2>
